$( document ).ready(function() {
  jQuery(".howWeWorkNav a").click(function(){
    jQuery(".howWeWorkNav a").removeClass('active');
    jQuery(this).addClass('active');
  });

  jQuery(".filter-container a").click(function(){
    jQuery(".filter-container a").removeClass('active');
    jQuery(this).addClass('active');
  });


  jQuery(".klikOmDeSearchTeOpenen").click(function(){
    jQuery(".searchBarCustom").fadeToggle();
  });

  $(".backToTop").click(function(){
    $("html").scrollTop(0);
  });
});



$(document).ready(function() {

  if(typeof Checkout === 'object'){
    if(typeof Checkout.$ === 'function'){
    }
  }

});


$( document ).ready(function() {
  if (window.location.href == "https://robinretail.com/" || window.location.href == "https://www.robinretail.com/" || window.location.href == "http://www.robinretail.com/" || window.location.href == "http://robinretail.com/") {
      var observer = new IntersectionObserver(function(entries) {
        if(entries[0].isIntersecting === true){
          jQuery("#howWeWorkNav1").removeClass("active");
          jQuery("#howWeWorkNav2").removeClass("active");
          jQuery("#howWeWorkNav3").removeClass("active");
          jQuery("#howWeWorkNav1").addClass("active");

        }
      }, { threshold: [1] });

      observer.observe(document.querySelector("#howWeWork1"));

      var observer2 = new IntersectionObserver(function(entries) {
        if(entries[0].isIntersecting === true){
          jQuery("#howWeWorkNav1").removeClass("active");
          jQuery("#howWeWorkNav2").removeClass("active");
          jQuery("#howWeWorkNav3").removeClass("active");
          jQuery("#howWeWorkNav2").addClass("active");

        }
      }, { threshold: [1] });

      observer2.observe(document.querySelector("#howWeWork2"));

      var observer3 = new IntersectionObserver(function(entries) {
        if(entries[0].isIntersecting === true){
          jQuery("#howWeWorkNav1").removeClass("active");
          jQuery("#howWeWorkNav2").removeClass("active");
          jQuery("#howWeWorkNav3").removeClass("active");
          jQuery("#howWeWorkNav3").addClass("active");

        }
      }, { threshold: [1] });

      observer3.observe(document.querySelector("#howWeWork3"));
  }
  
  existCondition = function (){
     if ($('.gf-option-box li a').length) {
        $(".gf-option-box li a").each(function(){
          var string = $(this).text();
          var newString = string.split(" (");
          $(this).text(newString[0]);
        });
     } else {
       setTimeout(existCondition, 500);
     }
  }
  
  existCondition();
});
